export interface Winner {
  place: '1st Place' | '2nd Place' | '3rd Place'
  /** First name + last initial. Full names stay out of the public bundle. */
  name: string
  title: string
  /** Copy in client/public/winners/2026/. Never a /photos/ URL: those keys contain the student's email. */
  photo: string
}

// Filled from scripts/print-winners.ts
export const WINNERS_2026: Winner[] = [
  { place: '1st Place', name: 'Brayden M.', title: 'Be Great', photo: '/winners/2026/1st.webp' },
  { place: '2nd Place', name: 'Laura S.', title: 'Where the Waves Remember', photo: '/winners/2026/2nd.webp' },
  { place: '3rd Place', name: 'Jake B.', title: 'Witness to the Sky', photo: '/winners/2026/3rd.webp' },
]
